import { useLocalStorage } from '@asgard/ui-common';
import { Button, Header, Modal, Paragraph } from '@asgard/ui-library';
import { faSignIn, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { useI18n } from 'hooks/useI18n';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { WORK_AT_MANFRED_KEY } from './JoinUsNotLoggedInModal.constants';
import { JoinUsNotLoggedInModalProps } from './JoinUsNotLoggedInModal.types';

export const JoinUsNotLoggedInModal: React.FC<JoinUsNotLoggedInModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useI18n('join-us');
  const { locale } = useRouter();
  const [, setWorkAtManfred] = useLocalStorage(WORK_AT_MANFRED_KEY, false);

  return (
    <Modal
      closeable={false}
      isOpen={isOpen}
      buttonsSlot={
        <>
          <ButtonLink
            sizes="sm"
            onClick={() => setWorkAtManfred(true)}
            href={`${getAppUrl(APP_URLS.join, locale)}?locale=${locale}`}
          >
            <FontAwesomeIcon icon={faSignIn} />
            <span>{t('modal.actions.register')}</span>
          </ButtonLink>

          <ButtonLink
            sizes="sm"
            variant="secondary"
            onClick={() => setWorkAtManfred(true)}
            href={`${getAppUrl(APP_URLS.login, locale)}?locale=${locale}`}
          >
            <FontAwesomeIcon icon={faSignIn} />
            <span>{t('modal.actions.login')}</span>
          </ButtonLink>

          <Button
            label={t('modal.actions.cancel')}
            startIcon={faTimesCircle}
            variant="bare"
            size="xs"
            onClick={onClose}
          />
        </>
      }
    >
      <Image
        src={getPublicPath('/images/joinUs/Spaceship_Planet.png')}
        alt=""
        width={152}
        height={164}
      />

      <Header as="h3" size="xl">
        {t('modal.title')}
      </Header>

      <Paragraph>{t('modal.desc')}</Paragraph>
    </Modal>
  );
};
